import React, { useState } from 'react';
import { Link, Route, Switch } from 'react-router-dom';
import PostCondition from './post-condition';
import PreCondition from './pre-condition';

const PrePostConditionRouter = (props) => {
  const index = props.location.pathname.lastIndexOf('/');
  const path = props.location.pathname.slice(0, index);
  let activeTab = props.location.pathname.slice(index + 1);
  const search = window.location.search;
  const moduleId = new URLSearchParams(search).get('moduleId');
  const scriptId = new URLSearchParams(search).get('scriptId');
  const manualScriptId = new URLSearchParams(search).get('manualScriptId');
  let [createCalled, setCreateCalled] = useState(false);
  let [disableCreate, setDisableCreate] = useState(false);
  const DisableCreateButton = (value) => {
    console.log(value);
    setDisableCreate(value);
  };
  return (
    <div className="page-table-body">
      <div className="content_area_style">
        <div className="pt-3 pb-3 border_style flex flex-wrap items-center">
          <label className="project_label flex-auto">Pre-Post Conditions</label>
          <div className="pr-4">
            <div className="flex flex-row ml-32">
              <div className="ml-auto pl-4">
                {global.permission.isEditAccess('testDevelopment') && (
                  <button
                    disabled={disableCreate}
                    onClick={() => {
                      setCreateCalled(true);
                      setTimeout(() => {
                        setCreateCalled(false);
                      }, 200);
                    }}
                    className="ml-3 primary-btn"
                  >
                    + {activeTab === 'Pre Condition' ? 'Pre Condition' : 'Post Condition'}
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="pre-post-bordr-style-common pt-2">
          <label
            className={`${activeTab === 'Pre Condition' ? ' selected_pre_post_common' : 'pre_post_style_common'}  ml-10 mb-px`}
          >
            <Link
              to={`${path}/Pre Condition?moduleId=${moduleId}&scriptId=${scriptId}&manualScriptId=${manualScriptId}`}
              onClick={() => {
                DisableCreateButton(false);
              }}
            >
              Pre Conditions
            </Link>
            {/* <span className="proj-count-style  px-2 py-0.5 ml-2 font-bold rounded-lg">{preCondition}</span> */}
          </label>
          <label
            className={`${activeTab === 'Post Condition' ? ' selected_pre_post_common' : 'pre_post_style_common'}  ml-8 mb-px`}
          >
            <Link
              to={`${path}/Post Condition?moduleId=${moduleId}&scriptId=${scriptId}&manualScriptId=${manualScriptId}`}
              onClick={() => {
                DisableCreateButton(false);
              }}
            >
              Post Conditions
            </Link>
            {/* <span class="proj-count-style  px-2 py-0.5 ml-2 font-bold rounded-lg">{postCondition}</span> */}
          </label>
        </div>
        <div className="table-height overflow-auto" id="journal-scroll">
          <Switch>
            <Route path={`${path}/Pre Condition`} exact={true} strict={true} key="pre-condition-page">
              <PreCondition
                MyAlert={props.MyAlert}
                DisableCreateButton={DisableCreateButton}
                createCalled={createCalled}
              />
            </Route>
            <Route path={`${path}/Post Condition`} exact={true} strict={true} key="post-condition-page">
              <PostCondition
                MyAlert={props.MyAlert}
                DisableCreateButton={DisableCreateButton}
                createCalled={createCalled}
              />
            </Route>
          </Switch>
        </div>
      </div>
    </div>
  );
};

export default PrePostConditionRouter;
